/* Converted to vanilla JS
   Replaces Angular-based email signup behavior with plain JavaScript.
   - Reads server-provided `data-*` attributes on the `.email-signup` element for initial values
   - Handles focus/active UI on email input
   - Enables/disables submit button based on GDPR checkbox + email presence
   - Submits JSON POST to /Umbraco/Api/EmailSignupFormApi/SubmitEmailSignupForm
   - Shows thank-you content on success and pushes `formSubmission` to dataLayer
*/

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-email-signup').forEach(function (block) {
        var signupWrapper = block.querySelector('.email-signup');
        var form = block.querySelector('.email-signup-form');
        var complete = block.querySelector('.form-complete');
        var emailInput = block.querySelector('.email-wrapper input.form-control[type="email"]');
        var checkbox = block.querySelector('.gdpr-wrapper input[type="checkbox"]');
        var btn = block.querySelector('.email-wrapper .btn');
        var gdprWrapper = block.querySelector('.gdpr-wrapper');

        var ES = {
            FormType: '',
            EmailAddress: '',
            GDPRAcceptance: undefined,
            PageMadeOn: '',
            EmailTemplateID: 0,
            ApiListId: ''
        };
        var formName = '';

        // Read dataset attributes (data-form-name, data-email-template-id, etc.)
        var dataset = signupWrapper ? signupWrapper.dataset : {};
        if (dataset) {
            if (dataset.formName) formName = dataset.formName;
            if (dataset.emailTemplateId) ES.EmailTemplateID = Number(dataset.emailTemplateId) || 0;
            if (dataset.pageMadeOn) ES.PageMadeOn = dataset.pageMadeOn;
            if (dataset.apiListId) ES.ApiListId = dataset.apiListId;
            ES.FormType = dataset.formType || ES.FormType || 'EmailSignup';
        }

        // fallback for PageMadeOn if server didn't provide it
        if (!ES.PageMadeOn || ES.PageMadeOn === '') {
            ES.PageMadeOn = (typeof window !== 'undefined' && window.location && window.location.pathname) ? window.location.pathname : '/';
        }

        // Ensure thank-you is hidden initially
        if (complete) complete.style.display = 'none';

        if (emailInput) {
            emailInput.addEventListener('focus', function () {
                if (gdprWrapper) {
                    gdprWrapper.classList.add('active');
                    gdprWrapper.style.display = '';
                }
                if (btn) btn.classList.add('active');
            });

            emailInput.addEventListener('input', function () { updateButtonState(); });

            emailInput.addEventListener('keypress', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    if (btn && !btn.classList.contains('disabled')) submit();
                }
            });
        }

        if (checkbox) {
            checkbox.addEventListener('change', function () {
                ES.GDPRAcceptance = checkbox.checked;
                updateButtonState();
            });
        }

        if (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                submit();
            });
        }

        function updateButtonState() {
            if (!btn) return;
            var emailVal = emailInput ? (emailInput.value || '').trim() : '';
            var enabled = (ES.GDPRAcceptance === true) && emailVal !== '';
            if (enabled) btn.classList.remove('disabled'); else btn.classList.add('disabled');
        }

        function submit() {
            if (!btn) return;
            if (btn.classList.contains('disabled')) return;

            ES.EmailAddress = emailInput ? (emailInput.value || '').trim() : '';

            if (ES.GDPRAcceptance == undefined || ES.GDPRAcceptance === false) {
                showError('Please accept the terms and conditions of this form.');
                return;
            }

            btn.disabled = true;

            fetch('/Umbraco/Api/EmailSignupFormApi/SubmitEmailSignupForm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json; charset=utf-8' },
                body: JSON.stringify(ES)
            }).then(function (res) { return res.json(); })
              .then(function (responseData) {
                try {
                    if (responseData && typeof responseData === 'object') {
                        if (responseData.EmailAddress !== undefined) ES.EmailAddress = responseData.EmailAddress;
                        if (responseData.EmailTemplateID !== undefined) ES.EmailTemplateID = responseData.EmailTemplateID;
                        if (responseData.ApiListId !== undefined) ES.ApiListId = responseData.ApiListId;
                    }
                } catch (e) { }

                if (responseData && responseData.success === true) {
                    if (form) form.style.display = 'none';
                    if (complete) complete.style.display = '';

                    if (formName && formName.length > 0) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ 'event': 'formSubmission', 'formName': formName });
                    }
                } else {
                    var errors = [];
                    if (responseData && Array.isArray(responseData.errors)) {
                        errors = responseData.errors.map(function (err) {
                            if (typeof err === 'string' && err.indexOf('Conditions Not Accepted') > -1) return 'Please accept the terms and conditions of this form.';
                            return err;
                        });
                    } else {
                        errors.push('An issue occurred when attempting to send your request.');
                    }
                    showError(errors.join(' '));
                }
            }).catch(function () {
                showError('An issue occurred when attempting to send your request.');
            }).finally(function () {
                btn.disabled = false;
            });
        }

        function showError(msg) {
            var errEl = block.querySelector('.email-signup-error');
            if (!errEl) {
                errEl = document.createElement('div');
                errEl.className = 'email-signup-error';
                errEl.style.color = '#c00';
                errEl.style.marginTop = '8px';
                var wrapper = block.querySelector('.form-wrapper') || block;
                wrapper.appendChild(errEl);
            }
            errEl.textContent = msg;
        }

        updateButtonState();
    });
});
